<template>
	<div>
        <div class="videoWrapper" v-if="!authenticated">
            <iframe width="560" height="315" :src="'https://www.youtube.com/embed/' + contentData.videoId" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
        <div v-else>
            <div class="form-group">
                <label>Video Id</label>
                <input type="text" class="form-control" v-model="contentData.videoId" />
            </div>
        </div>
	</div>
</template>

<script>
import $ from 'jquery';

	export default {
		name: 'videocontent-component',
		props: ['contentData', 'index', 'hide', 'dragging', 'authenticated'],
		methods: {
			toggleHide() {
				this.$emit('toggle-hide');
			},
			deleteSection() {
				this.$emit('delete')
				this.pod.sections.splice(index, 1);
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .videoWrapper {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        padding-top: 25px;
        height: 0;
    }

    .videoWrapper iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
